<template>
  <div class="usageDetailsCom ashComWrap">
    <div class="tableBox">
      <OriginalTable :tableHead="tableHead" :tableList="tableList" />
    </div>
    <div class="calendarBox">
      <Calendar />
    </div>
  </div>
</template>

<script>
import OriginalTable from "@/components/table/OriginalTable.vue";
import Calendar from "@/components/zixitong/buildingInfor/Calendar.vue";
export default {
  components: {
    OriginalTable,
    Calendar,
  },
  data() {
    return {
      tableHead: [
        { label: "时间", prop: "time" },
        { label: "使用人", prop: "user" },
        { label: "联系方式", prop: "phone" },
        { label: "用途", prop: "use" },
      ],
      tableList: [
        { time: "08:00-09:30", user: "张三", phone: 18899997777, use: "开会" },
        {
          time: "12:00-14:00",
          user: "李四",
          phone: 18899997777,
          use: "新员工培训",
        },
        { time: "15:00-15:30", user: "张三", phone: 18899997777, use: "开会" },
        { time: "18:50-22:45", user: "李四", phone: 18899997777, use: "开会" },
        {
          time: "23:30-04:00",
          user: "张三",
          phone: 18899997777,
          use: "C673项目CC节点研讨分析会",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.usageDetailsCom {
  @include setFlexAround;
  .tableBox {
    width: 66%;
    height: 96%;
  }
  .calendarBox {
    width: 30%;
    height: 96%;
  }
}
</style>
